import axios from "axios";
import store from "../store/index";
import axiosUrl from "./axios.service";

const API_URL = axiosUrl.getAxiosUrl();

class AccountManagersService {
  async getAccountManagersWithBasicInfo() {
    return await axios
      .get(API_URL + `accountManagers/getAccountManagersWithBasicInfo`)
      .then(response => {
        store.commit(
          "accountManagers/updateAccountManagersBasicInfoList",
          response.data
        );
      })
      .catch(error => {
        if (error) {
          store.commit("accountManagers/updateModalError", error.response.data),
            store.commit("accountManagers/enableModalError");
        }
      });
  }
}

export default new AccountManagersService();
